import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { TeamUserDto } from "@colab/shared";

// GET /api/admin/users/team — internal teammates (active|suspended) plus
// pending internal invites (status='invited'). Drives the Team tab on
// /admin/users.
export function useTeamUsers() {
  return useQuery<TeamUserDto[], ApiClientError>({
    queryKey: queryKeys.users.team(),
    queryFn: () => apiFetch<TeamUserDto[]>("/admin/users/team"),
  });
}
